import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { DataIcon } from '../icons/DataIcon';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';

export const ReportsNavButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isAtLocation = location.pathname === '/reports';
  const isActive = location.pathname.startsWith('/reports');

  const { t } = useTranslation();

  return (
    <NavbarIconButtonWithLabel
      active={isActive}
      label={t('Reports')}
      onClick={() => {
        if (!isAtLocation) {
          navigate('/reports');
        }
      }}
    >
      <DataIcon />
    </NavbarIconButtonWithLabel>
  );
};
